import { compose, isFunction } from 'underscore';

import { withError, withValidation } from '@bingads-webui-react/validation';
import { withAlwaysShowError, withFormError, withFormErrorGroup } from '@bingads-webui-campaign-react/form-error';
import { FocusableActuator, withActuation } from '@bingads-webui-campaign-react/actuator';
import { withAttentionBeacon, withAttentionBeaconGroupProxy, withAttentionBeaconPropsInjection, withAttentionBeaconRender } from '@bingads-webui-campaign-react/attention-beacon';
import { FormErrorBeaconAdapter } from './form-error-beacon-adapter';
import { ValidationBeaconAdapter } from './validation-beacon-adapter';
import { withAttentionBeaconActuation } from './with-attention-beacon-actuation';

const resolveFormErrorStaticConfig = FormErrorAdapterOrOptions => (
  isFunction(FormErrorAdapterOrOptions) ?
    { Adapter: FormErrorAdapterOrOptions } :
    FormErrorAdapterOrOptions
);


export const withControlErrors = (Control, FormErrorAdapterOrOptions, ValidationAdapter) => {
  const formErrorOptions = resolveFormErrorStaticConfig(FormErrorAdapterOrOptions);
  const AdapterControl = withFormError(withError(withValidation(Control, ValidationAdapter)), formErrorOptions);
  return AdapterControl;
};

export const withUnvalidatedControlErrors = (Control, FormErrorAdapterOrOptions) => {
  const formErrorOptions = resolveFormErrorStaticConfig(FormErrorAdapterOrOptions);
  const AdapterControl = withFormError(Control, formErrorOptions);
  return AdapterControl;
};

export const withContainerErrors = (Container, FormErrorAdapterOrOptions) => {
  const formErrorOptions = resolveFormErrorStaticConfig(FormErrorAdapterOrOptions);
  const AdapterControl = withFormError(Container, formErrorOptions);
  return AdapterControl;
};

export const withControlErrorHandling = (Control, Actuators = [FocusableActuator], Adapters = [FormErrorBeaconAdapter, ValidationBeaconAdapter], Consumers = []) => {
  const AdaptedControl = compose(withAttentionBeaconActuation, withAlwaysShowError, ...Consumers, withAttentionBeacon)(
    withActuation(
      Control,
      { Actuators }
    ),
    { Adapters }
  );
  return AdaptedControl;
};

export const withContainerRenderingErrorHandling = (Container, Actuators, Consumers = []) => {
  const AdaptedContainer = compose(withAttentionBeaconActuation, withAttentionBeaconRender, ...Consumers, withAttentionBeaconGroupProxy)(withActuation(
    withFormErrorGroup(Container),
    { Actuators }
  ));
  return AdaptedContainer;
};

export const withContainerPropInjectingErrorHandling = (Container, Actuators, Consumers = []) => {
  const AdaptedContainer = compose(withAttentionBeaconActuation, withAttentionBeaconPropsInjection, ...Consumers, withAttentionBeaconGroupProxy)(withActuation(
    withFormErrorGroup(Container),
    { Actuators }
  ));
  return AdaptedContainer;
};
